<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 3a9 9 0 1 0 7.6 13.8L21 21l-4.3-1.4A9 9 0 0 0 12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.7 8.9c0-.5.4-.9.9-.9h.7c.3 0 .6.2.7.5l.6 1.7c.1.3 0 .6-.2.8l-.6.6a5.6 5.6 0 0 0 2.6 2.6l.6-.6c.2-.2.5-.3.8-.2l1.7.6c.3.1.5.4.5.7v.7c0 .5-.4.9-.9.9-3.9 0-7.4-3.5-7.4-7.4Z" fill="currentColor"/>
</svg>
</template>
